import { SegmentedControl } from '@mantine/core';

export type ViewMode = 'table' | 'grid';

export default function TableGridToggle({ value, onChange }: { value: ViewMode; onChange: (v: ViewMode) => void }) {
  return (
    <SegmentedControl
      size="xs"
      data={[
        { value: 'table', label: 'List' },
        { value: 'grid', label: 'Grid' },
      ]}
      value={value}
      onChange={(v) => onChange(v as ViewMode)}
    />
  );
}
